import { base, token } from '../../api.ts';
import type { AgentInfo } from '../../agents-api.ts';
import { h, when } from '../../ui.ts';

/** What the agent showed the owner with its browser (design-docs/0031), newest first; a tap opens it full size. */
export function shotsCard(a: AgentInfo): HTMLElement | null {
  const shots = [...(a.shots ?? [])].reverse();
  if (!shots.length) return null;
  const src = (name: string) =>
    `${base()}/agents/${encodeURIComponent(a.id)}/shots/${encodeURIComponent(name)}?token=${encodeURIComponent(token())}`;
  return h(
    'div',
    { class: 'card shots-card' },
    h(
      'div',
      { class: 'card-head' },
      h('span', { class: 'label' }, 'Screenshots'),
      h('span', { class: 'chip' }, String(shots.length)),
    ),
    h(
      'div',
      { class: 'shots' },
      ...shots.map((s) =>
        h(
          'a',
          { class: 'shot', href: src(s.name), target: '_blank', rel: 'noopener' },
          h('img', { src: src(s.name), alt: s.caption, loading: 'lazy' }),
          h('span', { class: 'shot-caption' }, s.caption),
          h('span', { class: 'shot-time mono' }, when(s.at)),
        ),
      ),
    ),
  );
}
